import React, { useEffect, useState } from 'react'
import { Paper, Divider, Card } from '@mui/material'


import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import 'swiper/css/autoplay';
import 'swiper/css';



const OurCourses = (props) => {


    return (
        <>
            <div className='col-md-12 my-2'>
                <Paper> 
                    <div className='text-center p-3 pt-5'>
                        <h2> OUR COURSES </h2>
                    </div>
                    {/* <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'black' }} /> */}


                    <div className="row p-2">
                        <div className="col-12">
                            <div>
                                <Swiper
                                    // slidesPerView={3}
                                    // pagination={{ clickable: true }}
                                    spaceBetween={1}
                                    // loop={true}
                                    autoplay={true}
                                    navigation={{
                                        clickable: true,
                                        nextEl: '.review-swiper-button-next',
                                        prevEl: '.review-swiper-button-prev',
                                    }}
                                    modules={[Autoplay, Pagination, Navigation, Scrollbar]}
                                    breakpoints={{
                                        // when window width is >= 640px
                                        460: {
                                            //   width: 640,
                                            slidesPerView: 2,
                                        },
                                        // when window width is >= 768px
                                        768: {
                                            //   width: 768,
                                            slidesPerView: 3,
                                        },
                                        968: {
                                            //   width: 768,
                                            slidesPerView: 4,
                                        },

                                    }}
                                >


                                    {props.allCourse && props.allCourse.map((course, index) =>
                                    (

                                        <SwiperSlide>
                                            <div className="p-1">
                                                <Paper elevation={1} sx={{ borderRadius: '0%', minHeight: '200px', ':hover': {
                                                            boxShadow: 10, // theme.shadows[20]
                                                        } }} className='border border-primary'>
                                                    <div className='text-center p-2 d-flex justify-content-center align-items-center' style={{ minHeight: '64px' }}> <strong> {course.courseName} </strong>

                                                    </div>
                                                    <hr className='m-0 mx-2' />
                                                    <div className="m-2 p-2">
                                                        <div className=''>  <small><b> Duration: </b> {course.duration} Years</small> </div>
                                                        <div className=''> <small> <b>  Eligibility: </b> {course.eligibility}</small> </div>

                                                    </div>
                                                </Paper>
                                            </div>
                                        </SwiperSlide>

                                    ))}

                                </Swiper>
                            </div>
                        </div>
                    </div>










                </Paper>
            </div>
        </>
    )
}

export default OurCourses